import { all } from 'redux-saga/effects'

export const makeSaga = (yields) => function * () {
  yield all(yields)
}
